import { Alert, Button } from '@mm/components';
import PageModel from '@mm/state/model/PageModel';
import { LinkTypes, PromoterModel } from '@mm/state/model/PromoterModel';
import WidgetModel, { WidgetTypes } from '@mm/state/model/WidgetModel';
import { showInstaChampAlertSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  PathGraphContext,
  useNewGraphInstance,
} from '../../../common/widgets/common/PathGraph/PathGraph';
import { InactiveBotAlert } from '../../components/InactiveBotAlert/InactiveBotAlert';
import { StartBotsDialogueEditor } from '../startBotPromoters/common/StartBotsDialogueEditor/StartBotsDialogueEditor';
import './InstagramWelcomerPanel.pcss';
import { DialoguePreview } from '../../../modules/DailoguePreview/DialoguePreview';

type Props = {
  kind: LinkTypes;
  widgets: WidgetModel[];
  page?: PageModel;
  promoter?: PromoterModel;
};

const widgetsToExclude = [
  WidgetTypes.LIST,
  WidgetTypes.ITEM,
  WidgetTypes.VIDEO,
  WidgetTypes.ATTACHMENT,
  WidgetTypes.SMS_OPT_IN,
  WidgetTypes.SMS_OPT_IN_REPLY,
  WidgetTypes.OPT_IN,
  WidgetTypes.OTN,
  WidgetTypes.AUDIO,
];

export const InstagramWelcomerPanel = ({
  kind,
  widgets,
  page,
  promoter,
}: Props) => {
  const chatbot = useSelector(activeChatbotSelector);
  const pathGraph = useNewGraphInstance(promoter?.pageId);
  const [showInstaChampAlert, instagramUsername] = useSelector(
    showInstaChampAlertSelector,
  );

  if (!promoter || !page) return null;

  return (
    <div className="instagram-welcomer">
      <InactiveBotAlert />
      {!!showInstaChampAlert && (
        <Alert type="warning" showCloseIcon={false}>
          <div>
            This Instagram account was connected via InstaChamp. Making changes
            here may block you from making further changes in InstaChamp.
          </div>
          <Button
            onClick={() => {
              window.location.href = `/instachamp/@${instagramUsername}/dm_catch_all`;
            }}
          >
            Edit with InstaChamp
          </Button>
        </Alert>
      )}
      <div className="instagram-welcomer__dialogue-container">
        {promoter && (
          <PathGraphContext.Provider value={pathGraph}>
            <div className="instagram-welcomer__dialogue">
              <StartBotsDialogueEditor
                forInstagram
                chatbotId={chatbot.id}
                widgets={widgets}
                widgetsToExclude={widgetsToExclude}
                dialogueId={promoter.pageId}
                platforms={['instagram']}
              />
            </div>
          </PathGraphContext.Provider>
        )}
      </div>
    </div>
  );
};
